"use strict";
var proto = window.location.protocol;
var host = window.location.hostname;

//if (window.parent != window) {
//  // no iframe
//  window.top.location.href = document.location;
//}

var pE_args = window.bandeau_ENT = { current: "accueil", delegateAuth: true, layout_url: proto + '//' + host + '/layout.jsp', topapps_url: '/outils/latestTopApps.php' };

var pE, h, latestTopApps, tags, tries;
var searchWordsReg = [];
var rawSearch, searchAnyWords, searchWords;
var displayedApps;
var inProgress;
var favArray = [];
var onglet = "";

var mailMaxDisplay = 99;
var mailRefreshTimeout = 5000;

var blocAuth = '<div id="auth-container" class="col-6 col-lg-3 px-1 mx-0 color3"><div class="card square-size-by-width my-1"><a class="square-size-element" href="https://auth.univ-lorraine.fr/login?service=' + proto + '%2F%2F' + host + '%2FLogin%3FrefUrl%3D%2F"><span class="card-img icone-service o-connexion-1"></span><div class="card-img-overlay"><div class="card-title"><span class="title-text">Connexion</span></div><div class="card-text">Authentifiez-vous sur l\'ENT</div></div></a></div></div>';


if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function(searchElement, fromIndex) {

			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);
			// tslint:disable-next-line:no-bitwise
			var len = o.length >>> 0;

			if (len === 0) {
				return false;
			}
			// tslint:disable-next-line:no-bitwise
			var n = fromIndex | 0;
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			while (k < len) {
				if (o[k] === searchElement) {
					return true;
				}
				k++;
			}
			return false;
		}
	});
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.lastIndexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

function simpleEvery(a, fn) {
   var len = a.length;
   for(var i = 0; i < len; i++) {
       if (!fn(a[i])) return false;
   }
   return true;
}

function objectValues(o) {
    return h.simpleMap(Object.keys(o), function (k) { return o[k]; });
}

var diacriticsMap = [
      {'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
      {'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
      {'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
      {'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
      {'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
      {'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
      {'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
      {'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
      {'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
      {'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
];

// tableau de correspondance pour les urls non standards
var servicesAliasPatterns = {
  "ul-zcs-pers" : /mail.univ-lorraine.fr/ ,
  "ul-zcs-etud" : /mail.etu.univ-lorraine.fr/ ,
  "accueil" : /ent.univ-lorraine.fr\/Login\?refUrl|ent-test.univ-lorraine.fr/,
"ul-iframe-activer_compte" : /sesame.univ-lorraine.fr/,
"ul-iframe-ag2c" : /ag2c.univ-lorraine.fr/,
"ul-iframe-agatte" : /agatte.univ-lorraine.fr/,
"ul-iframe-aip" : /www.aip-primeca.net/,
"ul-iframe-anciens-sifac" : /sifac-exetabs.univ-lorraine.fr/,
"ul-iframe-annuairePersonnel" : /annuaire-web.univ-lorraine.fr/,
"ul-iframe-anti-plagiat" : /epoq.compilatio.net/,
"ul-iframe-apogee" : /apogee.univ-lorraine.fr/,
"ul-iframe-arche" : /arche.univ-lorraine.fr/,
"ul-iframe-arena" : /arena.univ-lorraine.fr/,
"ul-iframe-assistance_info" : /assistance-ent.univ-lorraine.fr/,
"ul-iframe-audioconf" : /audioconf.univ-lorraine.fr/,
"ul-iframe-budget-sifac" : /budget.univ-lorraine.fr/,
"ul-iframe-bul" : /bul.univ-lorraine.fr/,
"ul-iframe-calpadul" : /calpadul.univ-lorraine.fr/,
"ul-iframe-certifications" : /www.univ-lorraine.fr/,
"ul-iframe-charte-messagerie" : /ent.univ-lorraine.fr/,
"ul-iframe-cle-adm" : /cle.univ-lorraine.fr/,
"ul-iframe-conf_distance" : /visioconference.univ-lorraine.fr/,
"ul-iframe-depeche" : /formulaires.univ-lorraine.fr\/depeche/,
"ul-iframe-dn-numerique" : /numerique.univ-lorraine.fr/,
"ul-iframe-ecandidat" : /ecandidat.univ-lorraine.fr/,
"ul-iframe-ecandidat-gest" : /ecandidat-gest.univ-lorraine.fr/,
"ul-iframe-enquetes" : /enquetes.univ-lorraine.fr/,
"ul-iframe-evento" : /evento.renater.fr/,
"ul-iframe-fcp" : /formationdespersonnels.univ-lorraine.fr/,
"ul-iframe-filesender" : /filesender.renater.fr/,
"ul-iframe-geco" : /geco.univ-lorraine.fr/,
"ul-iframe-gec" : /gec.univ-lorraine.fr|edc.univ-lorraine.fr/,
"ul-iframe-hal" : /hal.univ-lorraine.fr/,
"ul-iframe-harpege" : /harpege.univ-lorraine.fr/,
"ul-iframe-helpdesk" : /helpdesk.univ-lorraine.fr|esup-portlet-helpdesk/,
"ul-iframe-home" : /ent*.univ-lorraine.fr/,
"ul-iframe-intranet-rh" : /intranet-rh.univ-lorraine.fr/,
"ul-iframe-lansad" : /edolang.univ-lorraine.fr/,
"ul-iframe-ulysse" : /search.ebscohost.com/,
"ul-iframe-marche-hebergement" : /ul.ialbatros.com/,
"ul-iframe-marche-transport" : /e-travelmanagement22.amadeus.com/,
"ul-iframe-mobul" : /mobul.tel.univ-lorraine.fr/,
"ul-iframe-mondossierweb" : /mdw.univ-lorraine.fr/,
"ul-iframe-montelephone" : /montelephone.univ-lorraine.fr/,
"ul-iframe-organisations-syndicales" : /syndicats.univ-lorraine.fr/,
"ul-iframe-pao" : /pao.univ-lorraine.fr/,
"ul-iframe-passul" : /carte-cezam.univ-lorraine.fr/,
"ul-iframe-petale" : /petale.univ-lorraine.fr/,
"ul-iframe-petites-annonces" : /petites-annonces.univ-lorraine.fr/,
"ul-iframe-emploi-du-temps-etu" : /edt.univ-lorraine.fr/,
"ul-iframe-planning-ade-ul-global" : /planning.univ-lorraine.fr/,
"ul-iframe-planning-ade-ul-pers" : /monade.univ-lorraine.fr/,
"ul-iframe-platine-offre" : /platine.univ-lorraine.fr/,
"ul-iframe-pret-materiel" : /pretmateriel.univ-lorraine.fr/,
"ul-iframe-repro" : /imprimer.univ-lorraine.fr/,
"ul-iframe-sbv3" : /sbv3.univ-lorraine.fr/,
"ul-iframe-sbv" : /sbv.univ-lorraine.fr/,
"ul-iframe-scodoc" : /scodoc.iutsd.univ-lorraine.fr/,
"ul-iframe-scope" : /scope.univ-lorraine.fr/,
"ul-iframe-semvacc" : /semvacc-test.univ-lorraine.fr/,
"ul-iframe-sifac-web" : /sifac.univ-lorraine.fr/,
"ul-iframe-site-bu" : /bu.univ-lorraine.fr/,
"ul-iframe-snw" : /snw.univ-lorraine.fr/,
"ul-iframe-stages" : /platine-e.univ-lorraine.fr/,
"ul-iframe-sympa-asso" : /listes.asso.univ-lorraine.fr/,
"ul-iframe-sympa-etu" : /listes.etu.univ-lorraine.fr/,
"ul-iframe-sympa" : /listes.univ-lorraine.fr/,
"ul-iframe-trouver" : /trouver.univ-lorraine.fr/,
"ul-iframe-videos" : /videos.univ-lorraine.fr/,
"ul-iframe-videothequeIECA" : /ieca-serv.univ-nancy2.fr/,
"ul-iframe-virtul" : /virtul.univ-lorraine.fr/,
"ul-iframe-wiki" : /wikidocs.univ-lorraine.fr/,
"ul-iframe-youpaces" : /youpaces.univ-lorraine.fr/

};

// format des urls ENT que l'on risque de rencontrer
var urls_ent = [
  /https:\/\/ent.univ-lorraine.fr\/.*\/p\/([a-z\-]*).*/,
  /https:\/\/ent.univ-lorraine.fr\/.*pCt=([a-z\-]*).*/
];

function asciifie(s) {
    if (!s) return s;
    diacriticsMap.forEach(function (v) {
	s = s.replace(v.letters, v.base);
    });
    return s;
}

var stopWordRegex = /^(de|la|le|l|a|les|et|des|d|en|du|un|une|est|dans|il|pour|au|que|qui)$/;

function removeStopWords(l) {
    return h.simpleFilter(l, function (w) { return !stopWordRegex.test(w); });
}

/* from "A Stemming Procedure And Stopword List For General French Corpora" 1999 Jacques Savoy */
/* modification: always return a substring */
function minimal_french_stemmer(w) {
  var len = w.length;

  if (len < 5) {
      // do nothing
  } else if (w[len - 1] === 'x') {
      len--;
      if (w[len - 2] === 'a' && w[len - 1] === 'u') len--;
  } else {
      if (w[len - 1] === 's') len--;
      if (w[len - 1] === 'r') len--;
      if (w[len - 1] === 'e') len--;
      if (w[len - 1] === 'e') len--; // for ée
      if (w[len - 1] === w[len - 2]) len--;
  }
  return len < w.length ? w.slice(0, len) : w;
}

function PseudoTrie() {}

PseudoTrie.prototype.insert = function(word) {
  var node = this;
  for (var i = 0; i < word.length; i++) {
    var c = word[i];
    node = node[c] || (node[c] = new PseudoTrie())
  }
  node.word = word;
};

PseudoTrie.prototype._searchRecursive = function(c, word, prevRow, r, maxDist) {
    var lastColumn = word.length;
    var row = [prevRow[0] + 1];

    for (var i = 1; i <= lastColumn; i++) {
        var repl = word[i - 1] === c ? 0 : 1;
        row[i] = Math.min(row[i - 1] + 1, prevRow[i] + 1, prevRow[i - 1] + repl);
    }

    if (row[lastColumn] <= maxDist && this.word) {
        r.push(this.word);
    }

    if (Math.min.apply(undefined, row) > maxDist) return; // give up

    this._recurse(word, row, r, maxDist);
}

PseudoTrie.prototype._recurse = function (word, row, r, maxDist) {
  for (var c in this) {
    if (this.hasOwnProperty(c) && c.length === 1) {
      this[c]._searchRecursive(c, word, row, r, maxDist);
    }
  }
};

PseudoTrie.prototype.search = function(word, maxDist) {
  var row = [];
  for (var i = 0; i <= word.length; i++) {
    row[i] = i;
  }

  var r = [];
  this._recurse(word, row, r, maxDist);
  return r;
};

function debounce(func, wait) {
    var timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            func();
        }, wait);
    };
}

function setClassIfNonBottom(elt, className) {
    function check() {
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
            h.removeClass(elt, className);
        } else {
            elt.className += " " + className;
        }
    }
    var check_ = debounce(check, 20);
    setTimeout(function () {
        window.addEventListener('scroll', check_);
        window.addEventListener('resize', check_);
        if (window.MutationObserver) {
            new MutationObserver(check_).observe(document, { childList: true, subtree: true });
        }
    });
    check();
}

function tomorrow() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    return d;
}

function raw_xhr(url) {
    var req = new XMLHttpRequest();
    if (!req) return;
    req.open("GET", url, true);
    req.responseType = 'text';
    req.send(null);
}



function sessionStorageGet(field) {
    try {
        var s = sessionStorage.getItem(field);
        var o = s && JSON.parse(s);
        if (o && o.expire > h.now()) return o.v;
    } catch (err) {}
    return null;
}
function sessionStorageSet(field, value, lifetime) {
    try {
        sessionStorage.setItem(field, JSON.stringify({ expire: Math.round(lifetime.getTime() / 1000), v: value }));
    } catch (err) {}
}

function formatAppField(s) {
  s = h.escapeQuotes(s);
  return searchAnyWords ? s.replace(searchAnyWords, function (word) {
    return "<b>" + word + "</b>";
  }) : s;
}

function getLocation(href) {
    var l = document.createElement("a");
    l.href = href;
    return l;
};

function getColor(app) {
  // Pour esn, pas de couleur mais on lui ajoute un id
  if (app.fname == "esn") return "' id='esn'";
  // Pour deleteallfav, pas de couleur mais on lui ajoute un id
  if (app.fname == "deleteallfav") return "' id='deleteallfav'";

  var color = "color1";
  if (app.parameters.color) {
    color = app.parameters.color;
  } else {
    // Si la couleur n'est pas définie, on en génére une aléatoirement
    var charSum = 0;
    var c;
    for( c=0;c<app.fname.length;c++) {
  	   charSum +=  app.fname.charCodeAt(c);
    }
    color = "color"+((charSum%5) + 1);
  }
  return color;
}

function computeLink11(app) {
  var tuile = computeLink(app);

  return "<div class='col-6 col-lg-3 px-1 mx-0 "+getColor(app)+"'>" + tuile + "</div>";
}
function computeLink12(app) {
  var tuile = computeLink(app);

  return "<div class='d-none d-lg-block col-6 col-lg-3 px-1 mx-0 "+getColor(app)+"'>" + tuile + "</div>";
}

function computeLink21(app) {
  var tuile = computeLink(app);

  return "<div class='d-lg-none col-6 col-sm-3 col-lg-2 px-1 mx-0 "+getColor(app)+"'>" + tuile + "</div>";
}

function computeLink22(app) {
  var tuile = computeLink(app);

  return "<div class='col-6 col-sm-3 col-lg-2 px-1 mx-0 "+getColor(app)+"'>" + tuile + "</div>";
}

function computeLink(app) {

  var deleteFavCode = "<span class='card-fav' data-fname='" + app.fname + "' data-level='2' title='retirer cette tuile des favoris'></span>";
	var addFavCode = "<span class='card-fav' data-fname='" + app.fname + "' data-level='1' title='ajouter cette tuile aux favoris'></span>";

  var fav = "";
  var ongletEnCours = h.simpleQuerySelector('#champFiltre').value;

	if (! document.getElementById('defaultTab')) {
		fav = addFavCode;
		// console.log("La recherche est "+ongletEnCours);
		// console.log("Les favoris sont "+favArray);
	}

	if ((favArray.indexOf(app.fname) >= 0) && ((ongletEnCours == "Tous")||(ongletEnCours == "Favoris")||(ongletEnCours == "")||(! document.getElementById('defaultTab')))) {
		fav = deleteFavCode;
	}

  if (app.fname == "esn") {
    // Pour l'ESN, pas de génération, c'est toujours la même chose
    return '<div class="card square-size-by-width my-1 carte-blanche"><div class="square-size-element" data-fname="esn"><a href="https://esn.univ-lorraine.fr/" target="_blank"><div class="card-img-overlay"><div class="card-title"><span class="d-md-none title-text">ESN</span><span class="d-none d-md-block title-text">État des Services Numériques</span>'+fav+'</div><div id="info-esn"><div id="info-esn-question"></div><div id="info-esn-global"></div></div></div></a></div></div>';
  }

  if ( (app.fname == "deleteallfav") && (ongletEnCours == "Favoris") ) {
    // Pour la tuile de suppression des favoris, pas de génération, c'est toujours la même chose
    return '<div class="card square-size-by-width my-1 carte-blanche"><div class="square-size-element" data-fname="deleteallfav"><a href="#Favoris" target="_blank"><span class="card-img icone-service o-delete-1"></span><div class="card-img-overlay"><div class="card-title"><span class="d-md-none title-text">Supprimer tous les favoris</span><span class="d-none d-md-block title-text">Supprimer tous les favoris</span>'+fav+'</div><div class="card-text">Attention, cette action est irréversible !</div></div></a></div></div>';
  }


  if ((app.parameters) && (app.parameters.alternativeMaximizedLink)) {
    // Use alternativeMaximizedLink if it exists
    var url = app.parameters.alternativeMaximizedLink.replace(/\/detached\//, "/max/");
  } else if (app.fullUrl) {
    var url = app.fullUrl.replace(/\/detached\//, "/max/");
  } else {
    var url = app.url;
  }
  if (url.indexOf("http") == -1) {
    url = pE.CONF.uportal_base_url + url;
  }
  var description = app.description || app.title;
  var iconUrl = "";
  if(app.parameters.iconUrl) {
	if(app.parameters.iconUrl.indexOf("http") == 0) {
		iconUrl = app.parameters.iconUrl;
	}
	else {
		iconUrl = pE.CONF.uportal_base_url + app.parameters.iconUrl;
	}
  }
  else {
	  iconUrl = pE.CONF.uportal_base_url+"/media/skins/icons/mobile/default.png";
  }

  //var iconUrl = (app.parameters.iconUrl)?(app.parameters.iconUrl.startsWith("http"))?app.parameters.iconUrl:pE.CONF.uportal_base_url + app.parameters.iconUrl:pE.CONF.uportal_base_url+"/media/skins/icons/mobile/default.png";

  var mailNonLus = ((app.fname == "ul-zcs-pers")||(app.fname == "ul-zcs-etud"))?"<span class='mailNonLus'>?</span>":"";

  var iconeService = "<img class='card-img icone-service' src='" + iconUrl + "'/>";
  // Utilisation des icones sous forme de font
  if (app.parameters.iconFont) {
    iconeService = "<span class='card-img icone-service o-" + app.parameters.iconFont + "-1'></span>";

  }
/*
  if(pE.DATA.user != "guest") {
    if (h.simpleQuerySelector('#champFiltre').value == "Favoris") {
    	var level = 0;
    	if(favArray.indexOf(app.fname) >= 0) {
    		level = 2;
    	}
    	fav="<span class='card-fav' data-fname='" + app.fname + "' data-level='2'></span>";
    }
  }
*/


  var target = "";
  var lien = getLocation(url);
  if (lien.hostname != window.location.hostname ) target = " target='_blank'";
  var a = "<a id='anchor-" + app.fname + "'></a><a class='square-size-element' title='" + h.escapeQuotes(description) + "' href='" + url + "' data-fname='" + app.fname + "'"+ target +">" +
           iconeService +
           "<div class='card-img-overlay'>" +
           "<div class='card-title'><span class='title-text'>" + formatAppField(app.text || app.title) + mailNonLus + "</span>"+fav+"</div>" +
					 // "<div class='card-title'><span class='title-text'>" + formatAppField(app.text || app.title) + mailNonLus + "</span></div>" +
					 "<div class='card-text'>" + formatAppField(description) +"</div>" +
					 "</div>" +
           "</a>";
  return "<div class='card square-size-by-width my-1'>" + a + "</div>";
}


function normalizeAppIds(appIds) {
    var map = {};
    h.simpleEachObject(pE.validApps, function (k, app) {
        if (app.parameters.alternativeMaximizedLink) {
          map[app.parameters.alternativeMaximizedLink] = k;
        }

    });

    return h.simpleMap(appIds, function (appId) {
      // On récupère les fnames dans les urls ENT plus complexes
      h.simpleEach(urls_ent, function (regex) {
        if (regex.test(appId)) {
          appId = RegExp.$1;
        }
      });

      // On teste les alias potentiels
      h.simpleEachObject(servicesAliasPatterns, function (app, regex) {
        if (regex.test(appId)) {
          appId = app;
        }
      });


      if (appId)
        return map[appId] || appId;
    });
}

function cachedAppValues(app) {
    var r = app._allValues;
    if (!r) {
     app._allValues="";
     var fields = ['fname', 'title', 'description', 'tags'];
     var paramFields = ['tags'];
     fields.forEach(function (field) {
       var v = app[field];
       if (v) {
         if (typeof v !== "string") v = v.join(",");
         app._allValues += asciifie(v).toLowerCase()+",";
       }
     });
     paramFields.forEach(function (field) {
       var v = app["parameters"][field];
       if (v) {
         if (typeof v !== "string") v = v.join(",");
         app._allValues += asciifie(v).toLowerCase()+",";
       }
     });
   }
   r = app._allValues;
   return r;
}

function matches_search(app) {
  if (searchWordsReg.length === 0) return true;
  var allValues = cachedAppValues(app);
  return simpleEvery(searchWordsReg, function (re) {
    return allValues.match(re);
  });
}

function computeTries() {
    tries = [];
    var fields = ['shortTitle', 'title', 'description', 'tags'];
    h.simpleEachObject(pE.validApps, function (appId, app) {
        var trie = new PseudoTrie();
        fields.forEach(function (field) {
            var v = app[field];
            if (v) {
                if (typeof v !== "string") v = v.join(",");
                removeStopWords(asciifie(v).toLowerCase().split(/[^\w_@]+/)).forEach(function (word) {
                    // On ne propose pas les tags d'onglets
                    if (!(word.startsWith("onglet") && word.endsWith("tag"))) {
                      trie.insert(word);
                    }

                });
            }
        });
        tries.push(trie);
    });
}
function approxSearch() {
    if (!tries) computeTries();
    var approx = {};
    var maxNb = 0;
    h.simpleEach(tries, function (trie) {
        var l = [];
        var maxDistUsed = 0;
        h.simpleEach(searchWords, function (w) {
            if (w.length <= 3) return;
            var max, maxDist = Math.min(w.length / 3, 4);
            for (max = 0; max <= maxDist; max++) {
                var r = trie.search(w, max);
                if (r.length > 0) {
                    var dist = minimal_french_stemmer(r[0]) === minimal_french_stemmer(w) ? 0 : max;
                    maxDistUsed = Math.max(maxDistUsed, dist);
                    l.push(r[0]);
                    break;
                }
            }
        });
        if (l.length && maxDistUsed >= 1) {
            if (l.length > maxNb) {
                approx = {};
                maxNb = l.length;
            }
            approx[l.join(" ")] = true;
        }
    });
    return Object.keys(approx);
}

function setSearchWords(toMatch) {

    rawSearch = toMatch;

    if (toMatch.length > 1) {
      if ((toMatch !== 'Tous') && (toMatch !== 'ongletTousTag') && (toMatch !== 'ongletFavoristag')){
        // Désactivation du glisser déplacer
        dragndropDisable();
      } else {
        dragndropEnable();
      }
      // Affichage de la croix de nettoyage
      var cleanSearch = $('#search .clean-Search ');
      cleanSearch.css('color','#797676');
      cleanSearch.css('cursor','pointer');

        var words = asciifie(toMatch).toLowerCase().split(/[^\w_@']+/);
        if (words[0] === '') words.shift();
        var lastWord = words.pop();
        words = removeStopWords(words);
        if (lastWord !== '') words.push(lastWord);
        searchWords = words;
        var stemmed_words = h.simpleMap(words, minimal_french_stemmer);

        searchWordsReg = h.simpleMap(stemmed_words, function (word) { return new RegExp(word); });
        searchAnyWords = new RegExp(words.concat(stemmed_words).join('|'), 'gi');
    } else {
      // On affiche tous les services, on laisse la possibilité d'ajouter des favorisASvg
      dragndropEnable();

      // On cache la croix de nettoyage
      var cleanSearch = $('#search .clean-Search ');
      cleanSearch.css('color','white');
      cleanSearch.css('cursor','auto');
        searchWords = searchWordsReg = [];
        searchAnyWords = null;
    }
}

function displayLinks() {
  var done = { 'https://idp.univ-lorraine.fr/Authn/RemoteUser': true, 'https://ent.univ-lorraine.fr/Login': true,
                'https://sesame.univ-lorraine.fr/admin/index.html': true, 'accueil': true,
                'https://ent.univ-lorraine.fr/outils/get-mail-infos.php?callback=window.writeMailInfos': true,
                'https://ent.univ-lorraine.fr/outils/get-user-infos.php?callback=window.writeUserInfos': true,
                'https://ent.univ-lorraine.fr/outils/get-user-shortcuts.php?callback=window.writeUserShortcuts': true,
                'https://ent.univ-lorraine.fr/': true, 'ul-iframe-presentationUL': true,
                'ul-iframe-nouveautes-pers': true, 'ul-iframe-nouveautes-etud': true, 'ul-cms-indisponibilite-ent': true,
                'https://sesame.univ-lorraine.fr/private/index.html': true,
                'http://www.univ-lorraine.fr/': true, 'intranet-manager-portlet-res-hum': true,
                'error': true, 'ul-iframe-audioconf': true,};


  /* Réactivation de l'affichage des onglets */
  h.simpleQuerySelector("#liste-tags-inner").innerHTML = "<ul>" + h.simpleMap(tags, function (tag) {
    var courant = asciifie("onglet"+tag+"tag").match(searchAnyWords || "Tous");
  	var className = courant ? 'selected' : '';
    var defaultTab = "";
    if (courant) defaultTab = onglet.match(tag) ? '<span id="defaultTab" class="o-favoriplein-1"/>' : '<span id="defaultTab" class="o-favorivide-1" data-onglet="'+tag.replace(/'/g, " ")+'"/>';

    var titleTab = "N'afficher que les tuiles de l'onglet "+tag;
    if (tag == 'Tous') titleTab = "Afficher tous vos services";
  	if (tag.indexOf('\'') > -1) {
  		return "<li class='" + className + "'><a href='#" + tag.replace(/'/g, " ") + "' title=\""+titleTab+"\">" + tag + "</a>" + defaultTab + "</li>";
  	}
  	return "<li class='" + className + "'><a href='#" + tag + "' title=\""+titleTab+"\">" + tag + "</a>" + defaultTab + "</li>";
  }).join(' ') + "</ul>";

  // Clic pour le choix de l'onglet par défaut
  $('#defaultTab.o-favorivide-1').click(function() {
    var ongletCourant = $(this).attr("data-onglet");
    if (confirm("Vous allez définir l'onglet "+ ongletCourant + " comme onglet par défaut. Voulez-vous poursuivre ?")){
      sendOnglet(ongletCourant);
      $(this).attr("class","o-favoriplein-1").off("click");
			onglet=ongletCourant;
    }
  });


  function matchingApps(appIds) {
    var l = [];
    h.simpleEach(appIds, function (appId) {
      //h.mylog("Traitement de "+appId);
      if (done[appId]) return;
      done[appId] = true;
      var app = pE.validApps[appId];

      if (app && app.tags && app.tags[0] === "__hidden__") return;
      if (app && matches_search(app))
      {
        l.push(app);
      }
    });
    return l;
  }


	function block1(apps, part2) {
    if (part2) {
      var links = h.simpleMap(apps, computeLink12);
    } else {
      var links = h.simpleMap(apps, computeLink11);
    }
		return links.join('');
	}

	function block2(apps, part1) {
    if (part1) {
      var links = h.simpleMap(apps, computeLink21);
    } else {
      var links = h.simpleMap(apps, computeLink22);
    }

		return links.join('');
	}

  function forcerPosition(liste, place, fname, nbFavoris) {
    // console.log("insertion de "+fname+" à la position "+place+" après "+nbFavoris+ " favoris");
    var appBienVue = null;
    for (var i=nbFavoris; i < liste.length; i++) {
      if (liste[i].fname == fname) {
        if ( i < place ) break; // On ne va pas le faire régresser donc on s'arrête là

        appBienVue = liste[i];
        // Suppression de l'app dans le flot normal
        liste.splice(i,1);
      }
    }
    if (appBienVue != null) {
      if (place <= nbFavoris) {
        // On place le service après les favoris
        place = nbFavoris+1;
      }
      // Insertion à la bonne position
      liste.splice(place-1,0,appBienVue);
    }
  }


  function ordreOnglet(l, nomOnglet) {
    var lEnOrdre = [];
    h.simpleEach(pE.DATA.layout.folders, function (tab) {
      if (asciifie(tab.title.toLowerCase()) == nomOnglet) {
        h.simpleEach(tab.portlets, function (appInTab) {
	  var app = pE.validApps[appInTab["fname"]];
	  if (app) { 
	    if (app.tags && app.tags[0] === "__hidden__") return;
            lEnOrdre.push(app);
	  }
	});
      }
    });
    return lEnOrdre;
  }

  var favArrayValues = Object.keys(favArray).map(function(e) {
    return favArray[e]
  })

  var newFav = (favArray ? normalizeAppIds(favArrayValues) : []);
  var newTopApps = (latestTopApps ? normalizeAppIds(latestTopApps) : []);

  var l = matchingApps(newFav.concat(newTopApps.concat(Object.keys(pE.validApps))));

  // On force la position de la tuile RH
  forcerPosition(l,3,"ul-iframe-intranet-rh",newFav.length);

  // Cas de la tuile de suppression de tous les favoris
    var deleteallfavapp = null;
    var placedeleteallfavapp = 5;
    // On supprime la tuile mais on vérifie d'abord que sa position n'était pas plus basse que celle souhaitée
    for (var i=0; i < l.length; i++) {
      if (l[i].fname == "deleteallfav") {
        if ( i < placedeleteallfavapp ) placedeleteallfavapp=i+1; // On ne va pas le faire régresser

        deleteallfavapp = l[i];
        // Suppression de l'app dans le flot normal
        l.splice(i,1);
	break;
      }
    }
    if ((deleteallfavapp != null) && ( searchWordsReg.length > 0 && "/ongletfavoristag/" == searchWordsReg[0].toString() )) {
      // Insertion à la bonne position uniquement si on est dans l'onglet favoris
      l.splice(placedeleteallfavapp-1,0,deleteallfavapp);
    }

  // On force la position de la tuile ESN
  forcerPosition(l,9,"esn",newFav.length);

  let patternOnglet = /\/onglet.*tag\//;
  if (searchWordsReg.length > 0 && patternOnglet.test(searchWordsReg[0])) {
	  var nomOnglet=searchWordsReg[0].toString().slice(7).slice(0,-4);
	  const ongletNonTraites = ["tous", "favoris"];
	  if (ongletNonTraites.indexOf(nomOnglet) === -1)  l = ordreOnglet(l, nomOnglet);
  }

    var html1 ="";
    var html2 ="";
    if (l.length === 0) {
        // La recherche ne retourne rien, on fait des suggestions
	var words = approxSearch();
	if (words.length) {
	    var suggestions = h.simpleMap(words, function (w) { return '<a href="#' + w + '">' + w + '</a>'; }).join(" ou ");
	    //console.log("on vous suggere " + suggestions);
	    html1 = '<div id="suggestions" class="col-6 col-lg-3 px-1 mx-0"><div class="card square-size-by-width my-1 carte-blanche"><div class="square-size-element"><div class="card-img-overlay"><div class="card-title"><span class="title-text">Suggestion</span><br/>Essayez&nbsp;: '+suggestions+'</div></div></div></div></div>';
	}
	//html += slider;

    } else if ((l.length === 1) && ( "/ongletfavoristag/" == searchWordsReg[0].toString() ) ) { 
	// On est dans l'onglet favoris et il n'y a que la tuile de suppression. On explique le fonctionnement des favoris.
       	html1 = '<div id="infoFavoris"><h2>Vous n\'avez aucun favori.</h2><p>Pour commencer à en ajouter, déplacez la tuile à ajouter en début de liste. <br/>Cette tuile <strong>ainsi que toutes celles la précédant à la fin du déplacement</strong> seront ajoutées aux favoris</p><div class="gifimg"><img src="images/fav_move_tile.gif"/></div><p>&nbsp;</p><p>Vous pouvez également ajouter un favori en appuyant sur l\'étoile <span class="card-fav"></span> s\'affichant en haut à droite des tuiles lors de la recherche d\'une application</p><div class="gifimg"><img src="images/fav_clic_star.gif"/></div><p>&nbsp;</p><p>&nbsp;</p></div>';

    } else if (pE.DATA.user == "guest") {
        // Hors connexion
        html1 = blocAuth + block1(l.slice(0,3));
        html1 += block1(l.slice(3,7),true);
        html2 = block2(l.slice(3,7),true);
        html2 += block2(l.slice(7));

    } else {
        // Cas standard
        html1 = block1(l.slice(0,4));
        html1 += block1(l.slice(4,8),true);
        html2 = block2(l.slice(4,8),true);
        html2 += block2(l.slice(8));
		}

        h.simpleQuerySelector("#liste-service1").innerHTML = html1;
        h.simpleQuerySelector("#liste-service2").innerHTML = html2;

	$( "#deleteallfav" ).click ( function() {
		if (confirm("Souhaitez-vous vraiment supprimer tous vos favoris ?\nCette action est irréversible !")) {
			sendFavs([]);
			return(false);
		}
		return(false);
	});

  displayedApps = l;

  if (pE.DATA.user != "guest")  {
    dragndropActivate();
  }

  // On recharge le code d'ESN pour que la pastille s'affiche correctement
  $.getScript("https://esn.univ-lorraine.fr/integration/esn.js");

};

window.onLoadTopApps = function (DATA) {
  if (latestTopApps) {
    sessionStorageSet("latestTopApps:" + pE.DATA.user, latestTopApps, tomorrow());
    displayLinks();
  } else {
    setTimeout(function () {
      window.onLoadTopApps();
    }, 200);
  }
};

function loadTopApps () {
  var elt = document.createElement("script");
  elt.setAttribute("type", "text/javascript");
  elt.setAttribute("src", (pE_args.topapps_url || pE.CONF.topapps_url));
  elt.setAttribute("async", "async");
  elt.setAttribute("charset", "utf-8"); // workaround IE ignoring Content-Type
  h.head().appendChild(elt);
}

function useHashParam() {
    var value = document.location.hash && decodeURIComponent(document.location.hash.replace(/^#/, ''));
    if (value) {
        var valueTag = value;

        if (tags.includes(value)) {
          valueTag = 'onglet' + value + "tag";
        }
        if (valueTag === 'ongletToustag') {
          valueTag = '';
          value = '';
        }
        // if ((value == "Tous") || (value == "Favoris")) dragndropEnable();
        var search_input = h.simpleQuerySelector('#champFiltre');
        search_input.value = value;
        setSearchWords(valueTag);
        displayLinks();

    } else if (onglet) {
      var url_cur = document.location.href;
      window.location.replace(url_cur.substring(0,url_cur.indexOf("#"))+"#" + onglet);
    }
}

function withInfo() {
  // remove splash screen
  //document.getElementById("loading").className = "hidden";

  var search_input = h.simpleQuerySelector('#search input');
  if (search_input.value) setSearchWords(search_input.value);
  /****
  * On supprime, c'est plus désagréable qu'autre chose
  if (window.innerHeight < 700 && search_input.scrollIntoView) {

      // auto scroll to top if small height
      search_input.onfocus = function () {
          search_input.scrollIntoView(true);
      };
  }*/
  search_input.oninput = function () {
    if (rawSearch === this.value) {
      // unchanged, do nothing (IE11 placeholder bug workaround)
      return;
    }
    if (document.location.hash) {
        history.pushState({}, "", document.location.href.replace(/#.*/, ''))
    }
    setSearchWords(this.value);
    displayLinks();
  };

  var search_input = h.simpleQuerySelector('#search input');
  search_input.onkeypress = function () {
		if (event.keyCode == 13)
 		{
			// Quand l'utilisateur tape entrée pour la recherche on l'envoie vers le premier résultat
			// sinon vers nutch
			if (displayedApps.length > 0) {
				event.preventDefault();
				if ((displayedApps[0].parameters) && (displayedApps[0].parameters.alternativeMaximizedLink)) {
					// Use alternativeMaximizedLink if it exists
					var url = displayedApps[0].parameters.alternativeMaximizedLink.replace(/\/detached\//, "/max/");
				} else if (displayedApps[0].fullUrl) {
					var url = displayedApps[0].fullUrl.replace(/\/detached\//, "/max/");
				} else {
					var url = displayedApps[0].url;
				}
        document.location = url;
      }
		}
  };

  h.simpleQuerySelector("#liste-service").onmousedown = function (event) {
      var elt = h.eltClosest && h.eltClosest(event.target, "a[data-fname]");
      var fname = elt && elt.getAttribute('data-fname');
      if (fname) {
          var index = 1 + h.simpleMap(displayedApps, function (e) { return e.fname }).indexOf(fname);
      }
  };

  latestTopApps = sessionStorageGet("latestTopApps:" + pE.DATA.user);
  if (pE.DATA.user == "guest" || latestTopApps) {
    displayLinks();
  } else {
    loadTopApps();
  }
}

function addTags() {
    //tags = ["Tous"];
    //Remise à zéro
    h.simpleEachObject(pE.validApps, function (k,app) {
      if (pE.validApps[k].tags){
        var indexFavTag = pE.validApps[k].tags.indexOf("ongletFavoristag");
        if ( indexFavTag > -1){
          pE.validApps[k].tags.splice(indexFavTag, 1);
        }
      }
      delete pE.validApps[k]._allValues;
    });

    pE.validApps["esn"]={"title": "ESN", "description": "État des Services Numériques", "url": "https://esn.univ-lorraine.fr", "fname": "esn", "parameters":{ }, "tags":[]};
    /* Favoris*/
    if (favArray !== undefined) {
      if ((favArray.indexOf("esn") >= 0) && (pE.validApps["esn"].tags.indexOf("ongletFavoristag") == -1)){
          pE.validApps["esn"].tags.unshift("ongletFavoristag");
      }
      // On ajoute le bouton de suppression de tous les favoris
      pE.validApps["deleteallfav"]={"title": "Supprimer tous les favoris", "description": "Attention cette action est irréversible", "url": "#Favoris", "fname": "deleteallfav", "parameters":{ }, "tags":[]};
      pE.validApps["deleteallfav"].tags = ["ongletFavoristag"];
    }


    /* Favoris */
		if (pE.DATA.user == "guest") {
			tags = ["Tous"];
		} else {
    	tags = ["Tous","Favoris"];
		}
    h.simpleEach(pE.DATA.layout.folders, function (tab) {
      if (tab.title.toLowerCase() !== "redirection") {
        h.simpleEach(tab.portlets, function (app) {
            if (typeof app.tags == "undefined") app.tags = [];
            if ((tab.title !== '') && (pE.validApps[app.fname]) && (pE.validApps[app.fname].tags.indexOf("onglet"+tab.title+"tag") == -1)){
                pE.validApps[app.fname].tags.unshift("onglet"+tab.title+"tag");
            }

            /* Favoris*/
            if (favArray !== undefined) {
              if ((favArray.indexOf(app.fname) >= 0) && pE.validApps[app.fname] && (pE.validApps[app.fname].tags.indexOf("ongletFavoristag") == -1)){
                  pE.validApps[app.fname].tags.unshift("ongletFavoristag");
              }
            }

        });
        tags.push(tab.title);
      }
    });
}

function writeMailTuile() {
  // inutile d'essayer d'afficher les mails de guest
  if (pE.DATA.user == "guest") return;
	if(pE.DATA.mailunread >= 0) {
		if(pE.DATA.mailunread > mailMaxDisplay) {
			pE.DATA.mailunread = mailMaxDisplay+'+';
		}
		var mailUnread = document.getElementsByClassName('.nonLus');
		if (mailUnread.length > 0 ) {
			var i;
			for (i = 0; i < mailUnread.length; i++) {
				mailUnread[i].innerHTML = pE.DATA.mailunread;
			}
		} else {
			var mailNonLus = document.getElementsByClassName('mailNonLus');
			var i;
			for (i = 0; i < mailNonLus.length; i++) {
				mailNonLus[i].innerHTML = '<span class="nonLus">'+pE.DATA.mailunread+'</span>';
			}
		}
	}
	if(pE.DATA.mailunread != undefined) {
		setTimeout(writeMailTuile, mailRefreshTimeout);
	}
	else {
		setTimeout(writeMailTuile, 1500);
	}
}

function getFavorites() {
	if(pE.DATA.user != "guest") {
    // Reset du tableau des favoris
    favArray.length = 0;

		// get favorites
		$.ajax({
			async:true,
			dataType: "json",
			url: "outils/user-pref.php",
			type : 'GET',
			success : function(favRes){
        favRes["fav"].forEach(function(fname){
          favArray.push(fname);
        });

        // Onglet par défaut
        onglet = favRes["onglet"]?favRes["onglet"]:"Tous";

        addTags();

        withInfo();
        useHashParam();
      	window.onhashchange = useHashParam;

			},
			error : function(resultat, statut, erreur){
				//console.log("has an error on favorites");
			}
		});
	} else {
    addTags();
    withInfo();
    useHashParam();
    window.onhashchange = useHashParam;
  }
}

var fait = false;
window.bandeau_ENT.onload = function (pE_) {
	if (fait) return;
    fait = true;
	pE = pE_;
	h = pE.helpers;

	getFavorites();

	h.onReady(function () {

		// get mode
		$.ajax({
                        async:true,
                        dataType: "json",
                        url: "outils/user-mode.php?callback=window.writeUserMode",
                        type : 'GET'
		});

		writeMailTuile();

		$( "#lienGoUp" ).click ( function() {
			$('html, body').animate( { scrollTop: $("#bandeau_ENT").offset().top }, 700 );
			return(false);
		});

    $('#search .clean-Search').on("click", function(){
      $('#champFiltre').val('');
      history.pushState({}, "", document.location.href.replace(/#.*/, ''));
      setSearchWords('');
      withInfo();
      dragndropEnable();
    });

		$('#champFiltre').on("click", function(){
      $('#champFiltre').val('');
    });


  });
};

/*******
** Cette fonction est désactivée pour le moment
** En la réactivant, pensez à remettre le js intro.min.js et introjs.min.css dans index-test.php
** Décommenter également la fonction skipIntro et l'appel à afficheIntro plus bas dans le fichier
function afficheIntro() {
  // Affichage de l'introduction
  var decouverte = introJs();
  decouverte.setOptions({
    nextLabel: "Suiv.",
    prevLabel: "Préc.",
    doneLabel: "Ne plus afficher",
    skipLabel: "Ne plus afficher",
    hidePrev: true,
    hideNext: true,
    steps: [
      {
        //element: document.querySelector('#liste-service'),
        intro: "Le mécanisme de favoris a changé. Il vous suffit maintenant de réorganiser les tuiles pour personnaliser votre environnement.<br/><br/>La tuile déplacée ainsi que toutes celles qui la précédent dans la liste seront ajoutées à vos favoris.",
        scrollTo: "tooltip"
      },
      {
        element: document.querySelectorAll('#liste-tags-inner li')[1],
        intro: "Vous pouvez limiter l'affichage aux tuiles placées en favori en choisissant l'onglet Favoris."
      },
      {
        element: document.querySelectorAll('span.card-fav')[0],
        intro: "Pour supprimer des favoris, cliquez sur la corbeille qui s'affiche à droite du nom sur la tuile."
      },
      {
        element: document.querySelector('#defaultTab'),
        intro: "Vous pouvez définir un onglet à afficher par défaut en cliquant sur l'étoile vide visible à droite de son nom lorsque cet onglet est actif. <br/><br/>L'onglet par défaut est celui avec l'étoile pleine."
      },
      {
        element: document.querySelector('#lienAvis'),
        intro: "Vous pouvez toujours nous laisser vos commentaires et idées d'améliorations.<br/><br/>Appuyez sur la touche Echap pour terminer la présentation ou \"Ne plus afficher\", ci-dessous, pour ne plus la revoir.",
        highlightClass: "numdroite"
      }
    ]});
  decouverte.onskip(function (){skipIntro()});
  decouverte.start();
}
*/
/*******
** Cette fonction n'est plus utilisée car elle était utilisée dans afficheIntro qui est désactivée pour le moment
** Pour réactiver, se référer à afficheIntro
function skipIntro() {
  // get intro
  $.ajax({
    async:true,
    dataType: "json",
    url: "outils/user-intro.php?skip=true",
    type : 'GET',
    success : function(res){
      //console.log("L'intro ne s'affichera plus");
    },
    error : function(resultat, statut, erreur){
      //console.log("erreur de maj intro");
    }
  });
}
*/

var isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	/*BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	},*/
	any: function() {
    //return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
		return (isMobile.Android() || isMobile.iOS());
	}
};

function deferIFrame() {
    var vidDefer = document.getElementsByTagName('iframe');
    for (var i=0; i<vidDefer.length; i++) {
        if(vidDefer[i].getAttribute('data-src')) {
            vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
        }
    }
}

function waitForPE(){
    if((typeof pE !== "undefined") && pE.DATA.ok){
        // Les données sont chargées et à jour
				if (pE.DATA.user == "guest") {
					// l'utilisateur n'est pas connecté, on recharge pour être certain qu'il ait l'interface guest
					fait = false;
					window.bandeau_ENT.onload(pE);
				}

        $(".main").ready(function() {
          $(".main").show();
  			  // Test if mobil to display information
  			  if( isMobile.any() ) {
    				var dissmiss = false;

    				var nameEQ = "hide_app=";
    				var ca = document.cookie.split(';');
    				for(var i=0;i < ca.length;i++) {
    					var c = ca[i];
    					while (c.charAt(0)==' ') c = c.substring(1,c.length);
    					if (c.indexOf(nameEQ) == 0) dissmiss=true;
    				}

    				if(dissmiss == false) {
    					if (isMobile.iOS()) {
    						//console.log("Mobile IOS");
    						$("#apps-lienApple").show();
    						$("#apps-lienGoogle").hide();
    					  $("#apps-modal").show();
    					}
    					else if (isMobile.Android()) {
    						//console.log("Mobile Android");
    						$("#apps-lienApple").hide();
    						$("#apps-lienGoogle").show();
    					  $("#apps-modal").show();
    					}

						$("#apps-dismiss").click( function(){
							if( $(this).is(':checked') ) {
								$("#apps-modal").hide();
								var date = new Date();
								date.setTime(date.getTime() + (10*365*24*60*60*1000));
								document.cookie = nameEQ+"true; expires="  + date.toUTCString() + "; path=/";
							}
						});
						$("#apps-modal").click( function(){
							$("#apps-modal").hide();
						});
    				}
    			}

          if (pE.DATA.user != "guest")  {
					/********
					** Affichage de l'intro désactivée pour le moment
					** Pour réactiver se référer à la fonction afficheIntro
  				  if(!isMobile.any()) {
  					  // get intro
  					  $.ajax({
  						async:true,
  						dataType: "json",
  						url: "outils/user-intro.php",
  						type : 'GET',
  						success : function(res){
  						  //console.log("retour intro OK pour "+ pE.DATA.user);
  						  if (!res["skip"]) afficheIntro();
  						},
  						error : function(resultat, statut, erreur){
  						  //console.log("erreur de récupération intro pour " + pE.DATA.user);
  						}
  					  });
  				  }
				*/


          }
              $("#champFiltre").focus();
        });
		// On affiche factuel une fois que le reste est chargé
		deferIFrame();

        $("#loading").hide();
    }
    else{
        setTimeout(waitForPE, 250);
    }
}

function sendOnglet(onglet) {
	// set favorite level
	$.ajax({
		async:true,
		dataType: "text",
		url: "outils/user-pref.php",
		type : 'GET',
		data : 'onglet=' + onglet,
		success : function(){
			// console.log("Préfs enregistées");
		},
		error : function(resultat, statut, erreur){
			// console.log("Une erreur s'est produite lors de l'enregistrement des favoris :"+resultat+",statut:"+statut+", erreur:"+erreur);
		}
	});
}

function sendMode(mode) {
	// set dark-mode/light-mode/auto
	$.ajax({
                async:true,
                dataType: "text",
                url: "outils/user-mode.php",
                type : 'GET',
                data : 'mode=' + mode,
                success : function(){
                        // console.log("Mode enregisté");
                },
                error : function(resultat, statut, erreur){
                        // console.log("Une erreur s'est produite lors de l'enregistrement du mode :"+resultat+",statut:"+statut+", erreur:"+erreur);
                }
        });
}

$( document ).ready(function() {

  waitForPE();

	// $("#bandeau_ENT").ready(function() {
		// $("#bandeau_ENT").show();
	// });


});
